import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from 'src/app/services/clipboard.service';
@Component({
  selector: 'app-enrich-filter',
  templateUrl: './enrich-filter.component.html',
  styleUrls: ['./enrich-filter.component.scss']
})
export class EnrichFilterComponent implements OnInit {
  public authToken = localStorage.getItem("token");
    public projectInfo = JSON.parse(sessionStorage.getItem('projectInfo'));
    userInfo: any = JSON.parse(localStorage.getItem("userInfo"))
    selectStatus:any;
    counts:any;
    enrichClicked = false;
  constructor(
    public serverService:ServerService,
    public clipBoardService:ClipBoardService,
    private dialogRef: MatDialogRef<EnrichFilterComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // console.log(this.data)
   }
  // selectStatus:any
  ngOnInit() {
  }
  enrich(){
  let body = {
    "only_count": true,
    "query":"*",
    "filters":{
        "project_id":this.projectInfo.id,
        "statuses":this.selectStatus
          }
};

this.serverService.bulk_lead_enrich(body,this.authToken).subscribe(
    data => {
        this.enrichClicked = true;
        this.counts = data.lead_count;
    },
    err => {
        this.clipBoardService.checkServerError(err, this.authToken)
    }
)
  }
  clear(){
    this.selectStatus = [];
    this.enrichClicked = false;
  }
  close() {
    this.dialogRef.close();
    this.enrichClicked = false;
}
enrichLead(){
  let body = {
    "only_count": false,
    "query":"*",
    "filters":{
        "project_id":this.projectInfo.id,
        "statuses":this.selectStatus
          }
};

this.serverService.bulk_lead_enrich(body,this.authToken).subscribe(
    data => {
        this.enrichClicked = true;
        this.counts = data.lead_count;
        this.dialogRef.close();
        this.enrichClicked = false;
    },
    err => {
        this.clipBoardService.checkServerError(err, this.authToken)
    }
)
}
}
